module.exports = __webpack_public_path__ + "img/pic_jindutiao_2.4b96bc35.png";